import React from 'react';
import './Autoparts.css';  // Add CSS for styling

// Importing images for each card
import part1 from '../../../imgs/Autoparts.webp';
import part2 from '../../../imgs/Logistics.webp';
import part3 from '../../../imgs/Publicutilities.webp';
import part4 from '../../../imgs/Homeapp.webp';

const Autoparts = () => {
  return (
    <div className='container'>
   <div className="Autops-grid" >
      <div className="autop" data-aos="fade-down-right">
        <img src={part1} alt="Part 1" className="autop-img" />
      </div>
      <div className="autop" data-aos="fade-down-left">
        <img src={part2} alt="Part 2" className="autop-img" />
      </div>
      <div className="autop" data-aos="fade-up-right">
        <img src={part3} alt="Part 3" className="autop-img" />
      </div>
      <div className="autop" data-aos="fade-up-left">
        <img src={part4} alt="Part 4" className="autop-img" />
      </div>
    </div>
    </div>
 
  );
}

export default Autoparts;
